import { omit, reduce } from "ramda";

import { ITemplatesState, ITemplatesKeyed } from "types/reducers";
import { RequestStatus } from "types/requests";
import { TemplatesActionTypes, TemplatesTypeKeys } from "actions/templates";

const initialState: ITemplatesState = {
  templates: {},
  requestStatuses: {
    getTemplates: RequestStatus.NOT_STARTED,
    postTemplate: RequestStatus.NOT_STARTED,
    deleteTemplate: RequestStatus.NOT_STARTED,
  },
};

export default function templates(
  state: ITemplatesState = initialState,
  action: TemplatesActionTypes
): ITemplatesState {
  switch (action.type) {
    case TemplatesTypeKeys.RECEIVE_TEMPLATES: {
      const newTemplates: ITemplatesKeyed = reduce(
        (acc: ITemplatesKeyed, template) => {
          acc[template.uuid] = template;
          return acc;
        },
        {},
        action.templates
      );
      return {
        ...state,
        templates: {
          ...state.templates,
          ...newTemplates,
        },
      };
    }

    case TemplatesTypeKeys.REMOVE_TEMPLATE: {
      return {
        ...state,
        templates: omit([action.uuid], state.templates),
      };
    }

    case TemplatesTypeKeys.SET_REQUEST_STATUS: {
      return {
        ...state,
        requestStatuses: {
          ...state.requestStatuses,
          [action.apiRequest]: action.status,
        },
      };
    }

    default:
      return state;
  }
}
